import { TripGroupDirection, TripGroupSlotType } from '@sparelabs/domain-logic'
import { IListModelQueryParamValues, IModelJsonValues } from '@sparelabs/http-client-utils'

export { TripGroupDirection, TripGroupSlotType }

export interface ITripGroupResponse extends IModelJsonValues {
  name: string
  description: string
  direction: TripGroupDirection
  slotType: TripGroupSlotType
  driverId: string | null
  requestRecurrenceIds: string[]
}

export interface ITripGroupPostBody {
  name: string
  description: string
  direction: TripGroupDirection
  driverId: string | null
  requestRecurrenceIds: string[]
}

export interface ITripGroupPatchBody extends Omit<Partial<ITripGroupPostBody>, 'direction'> {
  requestRecurrenceIds?: string[]
}

export interface ITripGroupListQueryParams extends IListModelQueryParamValues {
  driverId?: string
  direction?: TripGroupDirection
}
